import Box from 'components/shared/Box'
import styled from 'styled-components'
import { respondAbove } from 'styles/mediaQueries'

export const VariantWrapper = styled(Box)`
    width: 100%;
    background: ${({ theme }) => theme.colors.grayscale_0};
    padding: 16px;
    border-radius: 5px;

    @media ${respondAbove.md} {
        padding: 16px;
    }
`

export const StyledCrossedOutPrice = styled(Box)`
    position: relative;

    &::after {
        content: '';
        display: block;
        width: 100%;
        height: 1px;
        position: absolute;
        left: 0;
        top: 50%;
        background-color: ${({ theme }) => theme.colors.grayscale_800};
    }
`
